import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';

import '@/styles/theme.css';

import { router } from '@/app/router';
import {
  connectHttpToSession,
  restoreSession,
} from '@/features/auth/session.service';
import { initI18n } from '@/i18n/config';
import { AppProviders } from '@/providers/AppProviders';

/**
 * i18n est initialisé AVANT le premier rendu.
 *
 * Le coût est faible (un seul chunk de traductions) et le bénéfice important :
 * aucun écran n'a à gérer un état « traductions pas encore chargées », et on
 * n'affiche jamais une clé brute pendant une frame.
 */
await initI18n();

// Branche le transport HTTP sur la session (jeton + rafraîchissement).
connectHttpToSession();

// Restauration **non bloquante** : attendre l'aller-retour réseau ici
// retarderait le premier rendu d'autant, ce que la charte de performance
// interdit. Le store démarre en `loading` et l'UI s'adapte.
void restoreSession();

const container = document.getElementById('root');
if (!container) throw new Error('Élément #root introuvable dans index.html.');

createRoot(container).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
